import { i18n } from '../../../initializations';
import { useAsync } from 'react-async-hook';

export const useSupportedLanguages = () =>
    useAsync(async () => {
        return await i18n.getSupportedLanguages();
    }, []);
